"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  LayoutDashboard,
  GitBranch,
  MessageSquare,
  Users,
  Settings,
  Zap,
  BotMessageSquare,
} from "lucide-react";
import { useUIStore } from "@/stores/ui-store";
import { cn } from "@/lib/utils";

const navigation = [
  { name: "Panel", href: "/", icon: LayoutDashboard },
  { name: "Flujos", href: "/flows", icon: GitBranch },
  { name: "Conversaciones", href: "/conversations", icon: MessageSquare },
  { name: "Leads", href: "/leads", icon: Users },
  { name: "Demo", href: "/demo", icon: Zap },
  { name: "Configuración", href: "/settings", icon: Settings },
];

export function Sidebar() {
  const pathname = usePathname();
  const { sidebarCollapsed, toggleSidebar } = useUIStore();

  return (
    <aside
      className={cn(
        "flex h-screen flex-col border-r border-sidebar-border bg-sidebar transition-all duration-200",
        sidebarCollapsed ? "w-[60px]" : "w-60"
      )}
    >
      {/* Brand */}
      <div
        className={cn(
          "flex h-14 items-center border-b border-sidebar-border/50 px-4 cursor-pointer select-none",
          sidebarCollapsed && "justify-center px-0"
        )}
        onClick={toggleSidebar}
      >
        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-sidebar-primary/20 ring-1 ring-sidebar-primary/40">
          <BotMessageSquare className="h-4 w-4 text-sidebar-primary" />
        </div>
        {!sidebarCollapsed && (
          <span className="ml-2.5 text-sm font-semibold tracking-tight text-sidebar-foreground">
            LeadsAgent
          </span>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-0.5 p-2 pt-3">
        {navigation.map((item) => {
          const isActive =
            item.href === "/"
              ? pathname === "/"
              : pathname.startsWith(item.href);

          return (
            <Link
              key={item.name}
              href={item.href}
              title={sidebarCollapsed ? item.name : undefined}
              className={cn(
                "group flex items-center gap-3 rounded-md px-2.5 py-2 text-sm font-medium transition-all duration-150",
                isActive
                  ? "bg-sidebar-primary/15 text-sidebar-primary ring-1 ring-sidebar-primary/25"
                  : "text-sidebar-foreground/55 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
                sidebarCollapsed && "justify-center px-0 py-2.5"
              )}
            >
              <item.icon
                className={cn(
                  "h-4 w-4 shrink-0 transition-colors",
                  isActive
                    ? "text-sidebar-primary"
                    : "text-sidebar-foreground/35 group-hover:text-sidebar-accent-foreground"
                )}
              />
              {!sidebarCollapsed && <span>{item.name}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      {!sidebarCollapsed && (
        <div className="p-3 border-t border-sidebar-border/50">
          <p className="text-[10px] text-sidebar-foreground/30 tracking-wider uppercase">
            v0.1 · MVP
          </p>
        </div>
      )}
    </aside>
  );
}
